/**
 * Segmente le texte en alternance prose / code (fenced ou inline).
 * Les passes 1 (HTML→md) et 3 (alias) ne s'appliquent qu'aux segments 'prose'.
 *
 * Fence-safety : un <strong> à l'intérieur de ```html...``` ou de
 * `<strong>` doit traverser intact (cas pédagogique).
 *
 * Si une fence n'est pas refermée, on garde le tail en prose (conservative)
 * — la passe 4 (partialStreamCut) gère les tags partiels dans ce cas.
 */
export type SegmentKind = 'prose' | 'code';

export interface Segment {
  kind: SegmentKind;
  content: string;
}

const FENCE_RE = /(```[\s\S]*?```)|(`[^`\n]+`)/g;

export function splitFences(text: string): Segment[] {
  if (!text) return [{ kind: 'prose', content: '' }];

  const segments: Segment[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = FENCE_RE.exec(text)) !== null) {
    if (match.index > lastIndex) {
      segments.push({ kind: 'prose', content: text.slice(lastIndex, match.index) });
    }
    segments.push({ kind: 'code', content: match[0] });
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    segments.push({ kind: 'prose', content: text.slice(lastIndex) });
  }

  return segments.length > 0 ? segments : [{ kind: 'prose', content: text }];
}
